import { supabase } from '../supabase';

// Load all active lookup options, grouped by list name.
// Returns { [listName]: [{ label, code }, ...] } sorted by sort_order.
// One query; callers pick the lists they need (RE Parcel Type, PP Parcel Type, Exemption,
// Appeal Status, Parcel Status, Services, …). Reused across the parcel screen + elsewhere.
export async function loadLookupOptions() {
  const { data } = await supabase
    .from('lookup_options')
    .select('label, code, sort_order, lookup_lists(name)')
    .eq('active', true)
    .order('sort_order', { ascending: true });
  const byList = {};
  (data || []).forEach(o => {
    const name = o.lookup_lists?.name;
    if (!name) return;
    (byList[name] = byList[name] || []).push({ label: o.label, code: o.code });
  });
  return byList;
}

// Convenience: just the labels for one list (in sort order).
export const labelsFor = (byList, name) => (byList[name] || []).map(o => o.label);
